import { errorByCode } from "./errors";
import { db } from "./app";

const DEFAULT_TITLE = "Untitled";

export async function fetch({ userId }) {
  let error;
  let folders;

  try {
    const { docs } = await db
      .collection("folders")
      .where("userId", "==", userId)
      .get();

    folders = docs.reduce((acc, doc) => {
      acc[doc.id] = { id: doc.id, ...doc.data() };
      return acc;
    }, {});
  } catch ({ code, message }) {
    error = errorByCode(code);
  }

  return { error, folders };
}

export async function fetchById({ id }) {
  let doc = await db
    .collection("folders")
    .doc(id)
    .get();
  doc = doc || {};

  if (doc.exists) {
    return {
      id: doc.id,
      ...doc.data()
    };
  }
}

export function* create({ userId, title = DEFAULT_TITLE }) {
  let error;

  try {
    yield db.collection("folders").add({
      title,
      userId,
      createdAt: Date.now(),
    });
  } catch ({ code, message }) {
    error = errorByCode(code);
  }

  return { error };
}

export function* update({ id, title = DEFAULT_TITLE }) {
  let error;

  try {
    yield db
      .collection("folders")
      .doc(id)
      .update({
        title,
        updatedAt: Date.now(),
      });
  } catch ({ code, message }) {
    console.log(message);
    error = errorByCode(code);
  }

  return { error };
}

export function* destroy({ id }) {
  let error;

  try {
    yield db
      .collection("folders")
      .doc(id)
      .delete();
  } catch ({ code, message }) {
    error = errorByCode(code);
  }

  return { error };
}

export default {
  fetch,
  create,
  update,
  destroy
};



// WEBPACK FOOTER //
// ./src/services/firebase/folder.js